import cloneDeep from 'lodash.clonedeep'

export const resetStore = ({ store }) => {
    const initialState = cloneDeep(store.$state)
    store.$reset = () => store.$patch(cloneDeep(initialState))
}
